/**
 * The `noun_verbed` snake_case event-naming convention, enforced by the
 * `track()` wrapper so the analytics taxonomy can't drift per call site.
 */
const NOUN_VERBED_RE = /^[a-z0-9]+(?:_[a-z0-9]+)*$/;

export function isNounVerbedEventName(name: string): boolean {
  if (name.length === 0) return false;
  return NOUN_VERBED_RE.test(name);
}
